import React, { useState, useEffect } from "react";
import styles from "./QuestionPage.module.css";
import logo from "./images/unisologo.png"; // put your logo in this path
import {
  isTokenExpired,
  removeToken,
  getToken,
  decodeToken,
} from "../../utils/TokenUtils";
import { API_URL, ENDPOINTS, postData } from "../../constants/api";
import axios from "axios";
import { useLocation } from "react-router-dom";
import Header from "./header";
import MyFooter from "./my footer";

const QuixPage = () => {
  const [scheduleDate, setscheduleDate] = useState({});
  const location = useLocation();
  const { state } = location || {};
  const {
    student_id,
    class_id,
    semester_id,
    course_id,
    exam_type,
    chapter_id,
  } = state || {};

  const [questions, setQuestions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0); // 👈 show one question at a time
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const getQuestion = async () => {
      try {
        const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/web-quiz`;
        const body = {
          class_id,
          semester_id,
          course_id,
          exam_type,
          chapter_id,
        };
        const response = await postData(url, body);
        const q = response.data;
        setQuestions(q);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (student_id) {
      getQuestion();
    }
  }, [student_id, class_id, semester_id, course_id, exam_type, chapter_id]);

  const handleAnswer = (index, value, question_id) => {
    setAnswers((prev) => {
      const question = questions.find((q) => q["id~hide"] === question_id);
      let marks = 0;

      if (question) {
        if (question.type === "tf" || question.type === "choose") {
          if (
            value.trim().toLowerCase() ===
            question.correct_answer?.trim().toLowerCase()
          ) {
            marks = question.marks || 0;
          }
        }
      }

      return {
        ...prev,
        [question_id]: {
          answer: value,
          marks,
          question_id,
          type: question?.type || null,
        },
      };
    });
  };

  const handleNext = () => {
    if (currentIndex < questions.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handleSubmit = async () => {
    try {
      const token = getToken();
      const insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create/web_answer`;
      const currentDate = new Date().toISOString().split("T")[0];

      const answerRows = Object.values(answers).map((ans) => ({
        student_id,
        question_id: ans.question_id,
        marks: ans.marks,
        answer: ans.answer,
        user_id: student_id,
        date: currentDate,
      }));

      for (const row of answerRows) {
        await axios.post(insertUrl, row, {
          headers: { Authorization: token ? `Bearer ${token}` : "" },
        });
      }

      alert("Submitted successfully!");
      setSubmitted(true);
    } catch (error) {
      console.error("❌ Submission error:", error);
      alert("Failed to submit answers. Please try again.");
    }
  };

  if (submitted) {
    return (
      <>
        <Header />
        <div className={styles.container}>
          <h2>Thank you! Your answers have been submitted.</h2>
        </div>
        <MyFooter />
      </>
    );
  }

  const currentQuestion = questions[currentIndex];

  return (
    <>
      <Header />
      <div className={styles.container}>
        {questions.length > 0 && currentQuestion && (
          <div key={currentIndex} className={styles.questionCard}>
            <h3 className={styles.qText}>
              {currentIndex + 1}. {currentQuestion.name}{" "}
              <span className={styles.marks}>({currentQuestion.marks} marks)</span>
            </h3>

            {/* TRUE/FALSE */}
            {currentQuestion.type === "tf" && (
              <div className={styles.optionGroup}>
                {["True", "False"].map((opt) => (
                  <label key={opt} className={styles.option}>
                    <input
                      type="radio"
                      name={`q${currentIndex}`}
                      value={opt}
                      checked={
                        answers[currentQuestion["id~hide"]]?.answer === opt
                      }
                      onChange={() =>
                        handleAnswer(currentIndex, opt, currentQuestion["id~hide"])
                      }
                    />
                    {opt}
                  </label>
                ))}
              </div>
            )}

            {/* MULTIPLE CHOICE */}
            {currentQuestion.type === "choose" && (
              <div className={styles.optionGroup}>
                {currentQuestion.options.split(",").map((opt, i) => (
                  <label key={i} className={styles.option}>
                    <input
                      type="radio"
                      name={`q${currentIndex}`}
                      value={opt}
                      checked={
                        answers[currentQuestion["id~hide"]]?.answer === opt
                      }
                      onChange={() =>
                        handleAnswer(currentIndex, opt, currentQuestion["id~hide"])
                      }
                    />
                    {opt}
                  </label>
                ))}
              </div>
            )}

            {/* DIRECT QUESTION */}
            {currentQuestion.type === "direct" && (
              <textarea
                className={styles.directInput}
                placeholder="Write your answer here..."
                value={answers[currentQuestion["id~hide"]]?.answer || ""}
                onChange={(e) =>
                  handleAnswer(
                    currentIndex,
                    e.target.value,
                    currentQuestion["id~hide"]
                  )
                }
              />
            )}
          </div>
        )}

        {/* Navigation Buttons */}
        <div className={styles.buttons} style={{marginTop:'15PX'}}>
          {currentIndex < questions.length - 1 ? (
            <button className={styles.nextBtn} onClick={handleNext}>
              Next
            </button>
          ) : (
            <button className={styles.submitBtn} onClick={handleSubmit}>
              Submit
            </button>
          )}
        </div>
      </div>
      <MyFooter />
    </>
  );
};

export default QuixPage;
